import axios from 'axios'
import { CMSPath_Master, IS_BETA_BUILD } from '../config/constant';


export const getHotelList = async () => {

    const base_url = axios.create({baseURL: `${CMSPath_Master}/Connector/rest`})
    
    const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneyMasterConnectorSessionToken')}` }
    };

    let appType = "Prod";
    if(IS_BETA_BUILD) appType = "Beta"

    try {
        let data = await base_url.get(`/multiHotelApp/hotels?appType=${appType}`, config )
        localStorage.setItem('Cached_Hotel_List', JSON.stringify(data))

        return data
    } catch (error) {
        let cachedHotelList
        try {
            cachedHotelList = JSON.parse(localStorage.getItem('Cached_Hotel_List'))
          } catch (e) {
            console.error("Invalid Cached_Hotel_List JSON", e);
            cachedHotelList = null;
          }
        if (cachedHotelList) {
             return cachedHotelList
        }
        return error
    }
}


export const getHotelListUpdatingProps = () => {

    return async dispatch => {

        const base_url = axios.create({ baseURL: `${CMSPath_Master}/Connector/rest` })

        const config = {
            headers: { Authorization: `Bearer ${localStorage.getItem('GuestJourneyMasterConnectorSessionToken')}` }
        };

        dispatch({
            type: "UPDATE_LOCATION_DATA",
            payload: {
                status: "PENDING",
                payload: []
            }
        })

        let appType = "Prod";
        if(IS_BETA_BUILD) appType = "Beta"

        try {
            let res = await base_url.get(`/multiHotelApp/hotels?appType=${appType}`, config)

            dispatch({
                type: "UPDATE_LOCATION_DATA",
                payload: {
                    status: "SUCCESS",
                    payload: res.data.payload.data
                }
            })

            localStorage.setItem('Cached_Hotel_List_UPDATING_PROPS', JSON.stringify(res))

        } catch (error) {
            let cachedHotelList = localStorage.getItem('Cached_Hotel_List_UPDATING_PROPS')
            if (cachedHotelList) {
                let res = JSON.parse(localStorage.getItem('Cached_Hotel_List_UPDATING_PROPS'))
                dispatch({
                    type: "UPDATE_LOCATION_DATA",
                    payload: {
                        status: "SUCCESS",
                        payload: res.data.payload.data
                    }
                })
                return
            }

            dispatch({
                type: "UPDATE_LOCATION_DATA",
                payload: {
                    status: "FAILED",
                    payload: []
                }
            })
        }
    }
}